var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCube = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.9059C4 18.1467 4.42983 17.453 5.10962 17.115L32.6096 3.44267C33.1705 3.16384 33.8295 3.16384 34.3904 3.44267L61.8904 17.115C62.5702 17.453 63 18.1467 63 18.9059V53.0941C63 53.8533 62.5702 54.547 61.8904 54.885L34.3904 68.5573C33.8295 68.8362 33.1705 68.8362 32.6096 68.5573L5.10962 54.885C4.42983 54.547 4 53.8533 4 53.0941V18.9059Z",
    stroke: "#5A2FDE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19L33.5 32.1923M33.5 32.1923V68M33.5 32.1923L5 19",
    stroke: "#5A2FDE",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cube.4d6b562e.svg";
export { ForwardRef as ReactComponent };